/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { ComplexCtaCardFragment } from "@cosmos/hygraph-schema";

import {
	CosmosButton,
	CosmosCard,
	CosmosRichText,
	CosmosTextVariantEnum,
	EdsIcon,
	EdsIconType,
} from "@components/elements";
import { css } from "@panda/css";
import { HStack, VStack } from "@panda/jsx";

const styled = css({
	display: "flex",
	h: "full",
});

export function ComplexCtaCard({ icon, title, desc, button }: ComplexCtaCardFragment): React.JSX.Element {
	return (
		<CosmosCard className={`complex-cta-card ${styled}`} variant="material">
			<VStack alignItems="stretch" justifyContent="space-between" gap="eds.dimension.24" h="full">
				<VStack alignItems="flex-start" gap="eds.dimension.16">
					<HStack alignSelf="stretch" gap="eds.dimension.12" alignItems="center">
						<EdsIcon icon={icon as EdsIconType} />
						<CosmosRichText variant={CosmosTextVariantEnum.headingSM} html={title?.html} />
					</HStack>
					<CosmosRichText variant={CosmosTextVariantEnum.paragraphSM} color="eds.text.secondary" html={desc} />
				</VStack>
				<CosmosButton {...button} />
			</VStack>
		</CosmosCard>
	);
}
